var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idCardLoading"},[_c('Navbar',{attrs:{"title":"资质认证","isSpecialBack":true},on:{"goBack":_vm.handleBack}}),_c('progressField',{attrs:{"flag":1}}),_c('div',{staticClass:"progress-block"}),_c('div',{staticClass:"LiveDetection"},[_c('authenticAtionPending',{ref:"authenticAtionPendingRef"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }